import { render, staticRenderFns } from "./new-collection.vue?vue&type=template&id=4a0ea7d8"
import script from "./new-collection.js?vue&type=script&lang=js&external"
export * from "./new-collection.js?vue&type=script&lang=js&external"
import style0 from "./new-collection.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports